'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isobject = require('isobject');

var _isobject2 = _interopRequireDefault(_isobject);

var _Button = require('../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Container = require('./components/Container');

var _Container2 = _interopRequireDefault(_Container);

var _Content = require('./components/Content');

var _Content2 = _interopRequireDefault(_Content);

var _Pdf = require('./components/Pdf');

var _Pdf2 = _interopRequireDefault(_Pdf);

var _ButtonContainer = require('./components/ButtonContainer');

var _ButtonContainer2 = _interopRequireDefault(_ButtonContainer);

var _htmlParser = require('../../libs/htmlParser');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components
// Libs


var Document = function (_Component) {
  _inherits(Document, _Component);

  function Document() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Document);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Document.__proto__ || Object.getPrototypeOf(Document)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      html: null,
      generating: false
    }, _this.required = {}, _this.generators = [], _this.requiredFn = function (id, isRequired) {
      if (!isRequired) return function () {};
      _this.required[id] = false;
      return function (outcome) {
        _this.required[id] = outcome;
      };
    }, _this.checkRequired = function (error) {
      if (Object.values(_this.required).every(function (outcome) {
        return !!outcome;
      })) return false;
      error({
        message: 'Please sign the document',
        type: 'signDocument'
      });
      return true;
    }, _this.onGeneration = function (generator) {
      if (!(0, _isobject2.default)(generator) || !generator.start || !generator.end) return;
      _this.generators = [].concat(_toConsumableArray(_this.generators), [generator]);
    }, _this.execute = function () {
      var _this$props = _this.props,
          onError = _this$props.onError,
          onExec = _this$props.onExec;
      if (_this.checkRequired(onError)) return;
      Promise.all([].concat(_toConsumableArray(_this.generators)).map(function (_ref2) {
        var start = _ref2.start;
        return start();
      })).then(function () {
        var html = (0, _htmlParser.combine)(_this.dom);
        onExec(html);
        return [].concat(_toConsumableArray(_this.generators)).map(function (_ref3) {
          var end = _ref3.end;
          return end();
        });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Document, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          html = _props.html,
          parser = _props.parser,
          data = _props.data,
          required = _props.required;
      this.setState({
        html: (0, _htmlParser.parse)(html, {
          parser: parser,
          data: data,
          required: required,
          requiredFn: this.requiredFn,
          onGeneration: this.onGeneration
        })
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          children = _props2.children,
          loading = _props2.loading,
          dynamic = _props2.dynamic,
          onExec = _props2.onExec;
      var _state = this.state,
          html = _state.html,
          generating = _state.generating;
      return !html ? null : _react2.default.createElement(_Container2.default, null, _react2.default.createElement(_Content2.default, {
        className: 'Pdf',
        dynamic: dynamic
      }, _react2.default.createElement(_Pdf2.default, {
        className: 'PdfDocument',
        innerRef: function innerRef(dom) {
          _this2.dom = dom;
        }
      }, html)), !!onExec && _react2.default.createElement(_ButtonContainer2.default, null, _react2.default.createElement(_Button2.default, {
        loading: loading || generating,
        size: 'large',
        onClick: this.execute
      }, children)));
    }
  }]);

  return Document;
}(_react.Component);

Document.propTypes = {
  loading: _propTypes2.default.bool,
  html: _propTypes2.default.string,
  data: _propTypes2.default.object,
  parser: _propTypes2.default.object,
  required: _propTypes2.default.array,
  chlidren: _propTypes2.default.node,
  dynamic: _propTypes2.default.bool,
  onExec: _propTypes2.default.func,
  onError: _propTypes2.default.func
};
Document.defaultProps = {
  loading: false,
  html: '',
  data: {},
  parser: {},
  required: [],
  children: 'Done',
  dynamic: false,
  onError: function onError() {
    return null;
  }
};
exports.default = Document;